var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import ApiServices from "../../config/axiosConfig";
export const fetchDepartureLocale = ({ query, apiService }) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const response = yield apiService.get(`/locality?locality=${query}&searchType=All`);
        return response.data;
    }
    catch (error) {
        console.error('Erro ao obter dados:', error.message);
        throw error;
    }
});
export default { ApiServices };
//# sourceMappingURL=index.js.map